export const environment = {
  production: true,
  isMoc: false,
  isApiMoc: false,
  clientId: 'ef5ad2cd-17f4-4b32-bc28-9a75b95f64c9',
  authApiUrl: 'https://account.identakid.net/api',
  authAppUrl: 'https://account.identakid.net/#',
  districtOneRosterApiUrl: 'https://oneroster.ccssvm.com/api',
  version: 'v1.12.0'
};
